'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002478 from "./presto.-Two-Factor-Auth-View$$anon$78.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002480 from "./presto.-Two-Factor-Auth-View$$anon$80.js";
import * as $j_presto$002etypes$0024$002dSelected$002dSite$0024 from "./presto.types$-Selected-Site$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$77() {
  this.bIk = null;
  this.bIc = null;
  this.bId = false;
  this.bIl = null;
  this.bIm = false;
  this.bIp = null;
  this.bIi = null;
  this.bIj = false;
  this.bIe = null;
  this.bIf = false;
  this.bIg = null;
  this.bIh = false;
  this.bIn = false;
  this.bIo = false;
  this.bIk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bIp = "SelectedSite";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$77 as $c_Lpresto_TwoFactorAuthView$$anon$77 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$77.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$77;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$77() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$77 as $h_Lpresto_TwoFactorAuthView$$anon$77 };
$h_Lpresto_TwoFactorAuthView$$anon$77.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bIk;
});
$p.M = (function() {
  if ((!this.bId)) {
    this.bIc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bId = true;
  }
  return this.bIc;
});
$p.O = (function() {
  if ((!this.bIm)) {
    this.bIl = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bIm = true;
  }
  return this.bIl;
});
$p.D = (function() {
  return this.bIp;
});
$p.t = (function() {
  if ((!this.bIj)) {
    this.bIi = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("site", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("selected", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bIj = true;
  }
  return this.bIi;
});
$p.N = (function() {
  if ((!this.bIf)) {
    this.bIe = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002478.$c_Lpresto_TwoFactorAuthView$$anon$78(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aq, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bIf = true;
  }
  return this.bIe;
});
$p.Q = (function() {
  if ((!this.bIh)) {
    this.bIg = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002480.$c_Lpresto_TwoFactorAuthView$$anon$80();
    this.bIh = true;
  }
  return this.bIg;
});
$p.v = (function() {
  if ((!this.bIo)) {
    this.bIn = false;
    this.bIo = true;
  }
  return this.bIn;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee864) => ((p) => \u03b4scrutinee864.adJ(p)))($j_presto$002etypes$0024$002dSelected$002dSite$0024.$m_Lpresto_types$SelectedSite$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$77 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$77, "presto.TwoFactorAuthView$$anon$77", ({
  Tp: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$77 as $d_Lpresto_TwoFactorAuthView$$anon$77 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$77.js.map
